export const SELECTION_SOURCES = ["current", "recentlyPublished", "proposed"] as const;

export type SelectionSource = (typeof SELECTION_SOURCES)[number];

export const DEFAULT_SELECTION: SelectionSource = "proposed";

export const RETURN_TO_REVIEW = "review";
